module.exports = __webpack_public_path__ + "6e6b669f3aaffd752fa0b3ea22effc15.svg";